// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import BranchesForm from './BranchesForm';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(BranchesForm);
